import { IFollowUpSurveyForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IFollowUpSurveyForList,
    onConfirm: () => void,
    onCancel: () => void
}

const ResendSurveyEmail = (props: IProps) => {
    let fullName = props.data != null ? props.data.firstName + ' ' + props.data.lastName:'';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Resend of Survey Email to <span style={{ color: 'darkgreen', fontWeight: 'bold' }}>{fullName}</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Please confirm that you wish to resend the survey email to <strong>{fullName}</strong>.
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirmed</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ResendSurveyEmail;